var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 27.5999C21.511 27.5999 27.5999 21.511 27.5999 13.9999C27.5999 6.48883 21.511 0.399902 13.9999 0.399902C6.48883 0.399902 0.399902 6.48883 0.399902 13.9999C0.399902 21.511 6.48883 27.5999 13.9999 27.5999ZM20.302 11.802C20.9659 11.1381 20.9659 10.0617 20.302 9.39782C19.6381 8.73393 18.5617 8.73393 17.8978 9.39782L12.2999 14.9957L10.102 12.7978C9.43809 12.1339 8.36171 12.1339 7.69782 12.7978C7.03393 13.4617 7.03393 14.5381 7.69782 15.202L11.0978 18.602C11.7617 19.2659 12.8381 19.2659 13.502 18.602L20.302 11.802Z",
    fill: "#6EC313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cc1ce5a7.svg";
export { ForwardRef as ReactComponent };